module.exports = __webpack_public_path__ + "static/media/right.21691d72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/assets/right.svg
// module id = ./src/App/assets/right.svg
// module chunks = 0